import { css } from "@emotion/react";

import { sizeToken } from "../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";

export const items = css({
    marginTop: sizeToken(1),
});
